module.exports = __webpack_public_path__ + "media/partners/gas_station-42c086da.svg";